var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.828,
    height: 6.828,
    viewBox: "0 0 10.828 6.828",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Sort",
    transform: "translate(1.414 1.414)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_64038",
    "data-name": "Line 64038",
    x2: 4,
    y2: 4,
    fill: "none",
    stroke: "#053f7f",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_64039",
    "data-name": "Line 64039",
    x1: 4,
    y2: 4,
    transform: "translate(4)",
    fill: "none",
    stroke: "#053f7f",
    strokeLinecap: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.8a43be0384d8ea9ef4208cd020f841c2.svg";
export { ForwardRef as ReactComponent };